<template>
  <div class="pvc-tree-node">
    <div class="item-rect" :class="{opened: isOpened, green: (isLeaf && isChecked) || checkedAnyParent(data) }" @click="itemClick()" v-if="!isLeaf">
      <span class="chevron d-inline-block mr-3" :class="{opened: isOpened}">
        <i v-if="isOpened" class="fas fa-chevron-down"></i>
        <i v-if="!isOpened" class="fas fa-chevron-right"></i>
      </span>
      <p class="d-inline-block mb-0">{{ data.name }}</p>
    </div>
    <div class="children pl-5" v-if="hasChildren" v-show="isOpened">
      <pvc-tree-node
        v-for="child in data.children"
        :key="child.id"
        :data="child"
        :input="input"
        :product-name="baseProductName"
        :totalPercentage="totalPercentage"
      ></pvc-tree-node>
    </div>
    <div class="item-rect d-flex" :class="{green: (isLeaf && isChecked) || checkedAnyParent(data)}" @click="itemClick()" v-if="isLeaf">
      <div class="mr-4">
        <base-checkbox :class="additionalClass" :disabled="isDisabled" class="d-inline-block mb-0" @click.native="checkClick" v-model="checked" :label="data.name"></base-checkbox>
      </div>
      <div class="flex-grow-1" v-if="isChecked">
        <div class="d-flex align-items-center" style="justify-content: flex-end;">
          <!-- <span class="mr-2 ml-auto">PI-PC</span>
          <div style="width: 110px;" class="mr-2">
            <input
              :disabled="isDisabled"
              ref="pipc"
              class="form-control simple text-right"
              v-model="pipc"
              v-input-mask data-inputmask-mask="9{1,3}%-9{1,3}%"
            />
          </div> -->
          <div class="mr-0 d-flex align-items-center pr-3" v-if="input">
            <div class="base-control base-checkbox mb-0 form-group form-check form-check-inline">
              <input
                      class="styled-checkbox"
                      type="radio"
                      :value="100"
                      :disabled="isDisabled"
                      id="one"
                      v-model="postindustrial"
                      @change="hadlePiPcChange('pi', postindustrial); emitNameChange();"
              >
              <label style="font-weight: normal;" class="mb-0" for="one">Pre-consumer</label>
            </div>
            <div class="base-control base-checkbox mb-0 form-group form-check form-check-inline">
              <input
                      class="styled-checkbox"
                      type="radio"
                      :value="100"
                      :disabled="isDisabled"
                      id="two"
                      v-model="postconsumer"
                      @change="hadlePiPcChange('pc', postconsumer); emitNameChange();"
              >
              <label style="font-weight: normal;" class="mb-0" for="two">Post-consumer</label>
            </div>
          </div>

          <div class="mr-0 d-flex align-items-center pr-3" v-else>
            Pre-C-<input
                  style="border-bottom:0; width:60px;"
                  :disabled="isDisabled"
                  ref="postindustrial"
                  class="form-control simple pl-0 mr-1"
                  v-model.lazy="postindustrial"
                  @change="hadlePiPcChange('pi', postindustrial)"
                  v-input-mask
                  data-inputmask-mask="9{1,3}%"
          />

            <div class="flex-grow-1 pr-3">
              <vue-slider :direction="'rtl'" :disabled="isDisabled" style="width: 100px;" v-model="postconsumer"></vue-slider>
            </div>
            Post-C-
            <input
                    style="border-bottom:0; width:60px;"
                    :disabled="isDisabled"
                    ref="postconsumer"
                    class="form-control simple pl-1 pr-0"
                    v-model.lazy="postconsumer"
                    @change="hadlePiPcChange('pc', postconsumer)"
                    v-input-mask
                    data-inputmask-mask="9{1,3}%"
            />
          </div>

<!--          <div class="mr-2 d-flex align-items-center" v-if="!input">-->
<!--            <span class="mr-3">% of overall composition</span>-->
<!--            <div style="width: 80px;" class="mr-2">-->
<!--              <input-->
<!--                :disabled="isDisabled"-->
<!--                class="form-control simple text-right"-->
<!--                v-input-mask data-inputmask-mask="9{1,3}%"-->
<!--                v-model="percentage"-->
<!--                @blur="setCorrectMaxPosiblePercent('percentageInt')"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->

          <div class="mr-0 d-flex align-items-center" v-if="!input">
            <!-- <span class="mr-3">PI</span> -->
            <!-- <input
              style="border-bottom:0; width:75px;"
              :disabled="isDisabled"
              class="form-control simple pl-3 pr-0"
              v-input-mask data-inputmask-mask="9{1,3}%"
              v-model="percentage"
              @blur="setCorrectMaxPosiblePercent('percentageInt')"
            /> -->
            <div class="flex-grow-1 ml-3">
              <vue-slider
                      ref="slider"
                      :disabled="isDisabled"
                      style="width: 100px;"
                      v-model="percentageInt"
                      @change="setCorrectMaxPosiblePercent('percentageInt')"
                      @drag-end="onDragEnd('percentageInt')"
              ></vue-slider>
            </div>
            <input
                    style="border-bottom:0; width:75px;"
                    :disabled="isDisabled"
                    class="form-control simple pl-4 pr-0"
                    v-input-mask data-inputmask-mask="9{1,3}%"
                    v-model="percentage"
                    @blur="setCorrectMaxPosiblePercent('percentageInt')"
            />
            <div>
              <!-- <span class="ml-3">PC</span> -->
              <span class="mr-3"> of overall composition</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import BaseCheckbox from '../checkbox/BaseCheckbox';

  export default {
    name: 'PvcTreeNode',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      productName: {
        type: String,
        default: ''
      },
      totalPercentage: {
        type: Number,
        default: 0
      },
      input: {
        type: Boolean,
        default: () => true
      }
    },
    data () {
      return {
        isOpened: true,
        checked: false,
        percentage: 0,
        postconsumer: 0,
        postindustrial: 0,
        baseProductName: this.productName + ' ' + this.data.name,
        additionalClass: ''
      };
    },
    mounted () {
      this.$root.$on('pvcChanged', id => {
        if (id !== this.data.id) {
          this.additionalClass = 'input-muted';
          this.checked = false;
        } else {
          this.additionalClass = '';
        }
      });

      this.postconsumer = 100 - this.postindustrial;
      if (typeof this.materialValues !== 'undefined') {
        this.checked = typeof this.materialValues.checked === 'undefined' ? false : this.materialValues.checked;
        this.percentage = typeof this.materialValues.percentage === 'undefined' ? 0 : this.materialValues.percentage;
        this.postindustrial = typeof this.materialValues.postconsumer === 'undefined' ? 0 : this.materialValues.postindustrial;
        // postconsumer is calculated automatically
      }


    },
    watch: {
      percentage: {
        handler: function () {
          let t = this.percentage;
          if (typeof t === 'string' && t.indexOf('%') > -1) {
            t = t.replace('%', '');
          }
          t = parseInt(t);

          this.materialValues.percentage = t;
          this.setMaterialPercentage(t);
          // eslint-disable-next-line
          this.materialValues = deepCopy(this.materialValues);
        }
      },
      postconsumer: {
        handler: function (value) {
          let pi = this.percentStringToInt(value);
          if (pi > 100) {
            pi = 100;
          }
          this.postindustrial = 100 - pi;
          this.materialValues.postindustrial = this.postindustrial;

          this.materialValues.postconsumer = pi;
          // this.materialValues.postindustrial = this.postindustrial;
          // this.postconsumer = 100 - this.postindustrial;

          // this.materialValues.postconsumer = this.postconsumer;
          // // eslint-disable-next-line
          // this.materialValues = deepCopy(this.materialValues);
        }
      },
      checked: {
        handler: function () {
          this.materialValues.checked = this.checked;
          // eslint-disable-next-line
          this.materialValues = deepCopy(this.materialValues);
        }
      },
    },
    computed: {
      percentageInt: {
        get () {
          let t = this.percentage;
          if (typeof t === 'string' && t.indexOf('%') > -1) {
            t = t.replace('%', '');
          }
          t = parseInt(t);
          return t;
        },
        set (value) {
          this.percentage = value;
        }
      },
      materialValues: {
        get () {
          let ret = {};
          this.composition.materials.forEach(e => {
            if (e.material_id === this.data.id) {
              ret = e;
            }
          });
          return ret;
        },
        // eslint-disable-next-line
        set (value) {
          const t = this;
          let found = false;
          this.composition.materials.forEach(e => {
            if (e.material_id === t.data.id) {
              e = value;
              found = true;
            }
          });
          if (!found) {
            this.composition.materials.push({
              material_id: this.data.id,
              percentage: 0,
              postindustrial: 0,
              postconsumer: 0,
              checked: this.checked
            });
          }
        }
      },
      // pipc: {
      //   get () {
      //     return this.postindustrial + '-' + this.postconsumer + '%';
      //   },
      //   set (value) {
      //     // eslint-disable-next-line
      //     let selection = this.$refs.pipc.selectionStart ? this.$refs.pipc.selectionStart : 0;
      //     // eslint-disable-next-line
      //     let dp = sanitizeDoublePercents(value, selection);
      //     this.materialValues.postindustrial = this.postindustrial = dp.postindustrial;
      //     this.$nextTick(() => {
      //       this.$refs.pipc.selectionStart = selection;
      //       this.$refs.pipc.selectionEnd = selection;
      //     });
      //   }
      // },
      id () {
        return 'base-pvc-tree-' + this._uid;
      },
      hasChildren () {
        return this.data.children && this.data.children.length > 0;
      },
      isLeaf () {
        return !this.hasChildren;
      },
      isChecked () {
        return this.checked;
      },
      composition () {
        return this.$store.getters['userCompositions/current'];
      },
      materials () {
        return this.$store.getters['materials/materials'];
      },
      isDisabled () {
        return !!this.composition.id;
      }
    },
    methods: {
      percentStringToInt(value) {
        let t = value;
        if (typeof t === 'string' && t.indexOf('%') > -1) {
          t = t.replace('%', '');
        }
        t = parseInt(t);
        return t;
      },
      hadlePiPcChange(type = 'pi', value) {
          let v = this.percentStringToInt(value);

          if (v > 100) {
            v = 100;
          }

          if (type === 'pi') {
            this.postconsumer = 100 - v;
            this.postindustrial = v;

            this.materialValues.postindustrial = v;
          } else {
            this.postindustrial = 100 - v;
            this.postconsumer = v;

            this.materialValues.postconsumer = v;
          }
      },
      onDragEnd(name) {
        this.$refs.slider.setValue(this[name]);
      },
      setCorrectMaxPosiblePercent(name) {
        if (typeof this[name] === 'string') {
            this[name] = 0;
          return;
        }
        setTimeout(() => {
          if (this.totalPercentage > 100) {

            const newValue = this[name] - (this.totalPercentage - 100);

            this[name] = newValue;
          }
        }, 0);
      },
      checkClick () {
        this.materialValues.checked = this.checked;
        if (this.input) {
          this.$root.$emit('pvcChanged', this.data.id);
        }
        this.emitNameChange();
      },
      emitNameChange() {
        if (this.input) {
          let name = this.baseProductName;

          if (this.postconsumer === 100) {
            name += ' Post-C';
          } else {
            name += ' Pre-C';
          }

          this.$root.$emit('productNameUpdated', name);
        }
      },
      setMaterialPercentage (percentage) {
        let element = this.composition.materials.find(e => e.material_id === this.data.id);

        if (!element) {
          element = {
            percentage: 0
          };
        }
        element.percentage = percentage;
        // this.setCorrectMaxPosiblePercent('percentage');
      },
      itemClick () {
        this.isOpened = !this.isOpened;
      },
      checkedAnyParent(data) {
        function traverseTree(tree) {
          let ret = typeof tree.values !== 'undefined' && typeof tree.values.checked !== 'undefined' && tree.values.checked;
          if (ret) {
            return true;
          }

          if (typeof tree.children !== 'undefined' && tree.children.length) {
            tree.children.forEach((element) => {
              if (typeof element.values !== 'undefined' && element.values.checked) {
                ret = true;
              }
              if (!ret && (typeof element.children !== 'undefined' && element.children.length > 0)) {
                for(let i = 0; i < element.children.length; i++) {
                  if (!ret) {
                    ret = traverseTree(element.children[i]);
                  }
                }
              }
            });
          }
          return ret;
        }
        return traverseTree(data);
      }
    },
    components: {
      BaseCheckbox
    },
  };

</script>

<style>
  .base-control.base-checkbox.input-muted .styled-checkbox + label:before {
    background-color: #ddd;
  }
</style>
